import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

function ResetPassword({ onComplete }) {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleUpdatePassword = async () => {
    setError('');
    setMessage('');

    if (!password || !confirmPassword) {
      setError('Please fill in both fields.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }

    setLoading(true);

    const { error } = await supabase.auth.updateUser({ password });

    if (error) {
      setError('Error: ' + error.message);
      setLoading(false);
      return;
    }

    setMessage('✅ Password updated successfully!');
    setLoading(false);

    setTimeout(() => {
      onComplete();
    }, 2000);
  };

  return (
    <div>
      <div className="header">
        <h2>🔐 Set New Password</h2>
        <p>Enter your new password below</p>
      </div>

      <input
        className="input"
        placeholder="New Password"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <input
        className="input"
        placeholder="Confirm New Password"
        type="password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />

      <button className="btn btn-primary" onClick={handleUpdatePassword} disabled={loading}>
        {loading ? 'Updating...' : 'Update Password'}
      </button>

      {message && <div className="success-message">{message}</div>}
      {error && <div className="error-message">{error}</div>}
    </div>
  );
}

export default ResetPassword;